import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, onUpdated } from 'vue';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'HtmlBlock',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const content = computed(() => props.block.fields.MultiRowText);

let lastJobylonCheck = false;

onUpdated(() => {
  if (typeof window === 'undefined') return;

  if (!document.getElementById('jobylon-jobs-widget')) {
    lastJobylonCheck = false;
    return;
  }

  if (!lastJobylonCheck) {
    lastJobylonCheck = true;
    loadJobylonScript();
  }
});

function loadJobylonScript() {
  /** * CONFIGURATION ** */
  window.jbl_company_id = 2028;
  window.jbl_version = 'v2';
  window.jbl_page_size = 10;

  /** * DON'T EDIT BELOW THIS LINE ** */
  (function () {
    const el = document.createElement('script');
    el.src = 'https://cdn.jobylon.com/embedder.js';
    el.type = 'text/javascript';
    el.async = true;
    const d = (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]);
    d.appendChild(el);
  }());
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "html-block",
    innerHTML: _unref(content)
  }, null, 8, _hoisted_1))
}
}

})